import { useEffect, useState } from "react";
import Loader from "react-spinners/SquareLoader";
import styled from "styled-components";

import { useFirebase } from "../../hooks/useFirebase";
import {
  useGnarlyGoatsContracts,
  useGnarlyGoatsContractsState
} from "../../hooks/useGnarlyGoatsContracts";
import { Token, useTokens } from "../../hooks/usePaginatedTokens";
import {
  Button,
  DashboardWrapper,
  ElementWrapper,
  Interface,
  Text,
  Title
} from "../../theme/components";

const TokensWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
	grid-auto-rows: minmax(100px, auto);
	min-width: fit-content;
	border-sizing: border-box;
	margin: 2rem 0 0 0;
	${({ theme }) => theme.mediaWidth.upToSmall`
		grid-template-columns: repeat(2, 1fr);
  	`};
`

const StyledVideo = styled.video`
	width: 100%;
	height: auto;
	border-sizing: border-box;
	:hover {
		cursor: pointer;
	}
`

const MintPassDashboard = (props: any) => {
	const { accountMintPassBalance, accountBalance } =
		useGnarlyGoatsContractsState()

	// const { mintPassTokens } = useTokens()

	const [tokenImages, setTokenImages] = useState<string[]>()

	const { getAccountTokens } = useFirebase()

	const [mintPassTokens, setMintPassTokens] = useState<Token[]>([])

	const fetchTokenImages = async (tokens: Token[]) => {
		const fetchTokenImageData = Promise.all(
			tokens.map(async (token) => {
				const res = await fetch(token.tokenUrl)
				const imageBlob = await res.blob()
				const imageObjectURL = URL.createObjectURL(imageBlob)
				setTimeout(() => {}, 1500)
				return imageObjectURL
			})
		)
		const response = await fetchTokenImageData
		setTokenImages(response)
	}

	useEffect(() => {
		async function init() {
			// console.log('Getting account tokens')
			// var tokens = await getAccountTokens()
			// console.log(tokens)

			var tokens = await getAccountTokens()
			console.log(tokens)
		}
		init()
	}, [accountMintPassBalance, accountBalance])

	// useEffect(() => {
	// if (!!mintPassTokens) {
	// fetchTokenImages(mintPassTokens)
	// }
	// }, [mintPassTokens])

	/**
	 * generate array of token elements from token metadata
	 */
	const tokenElements = mintPassTokens?.map((token: Token, i: number) => {
		if (!!tokenImages && tokenImages.length > 0) {
			return (
				<div key={`mintpass-${token.tokenId}`}>
					<StyledVideo src={tokenImages[i]} autoPlay loop muted></StyledVideo>

					<Interface col>
						<Title color2 fontSize={12}>
							{`Mint Pass #` + token.tokenId}
						</Title>
					</Interface>
				</div>
			)
		} else {
			return (
				<Loader
					color="#2172E5"
					loading={true}
					size={100}
					css={`
						padding: 10px;
						margin: 1rem;
					`}
				/>
			)
		}
	})

	return (
		<DashboardWrapper>
			<Interface justifyContent="center">
				<Text raw primary3>
					Mint Pass Balance:
				</Text>

				<Text indent color2>{`${accountMintPassBalance ?? 0} ${
					accountMintPassBalance === 1 ? 'Pass' : 'Passes'
				}`}</Text>
			</Interface>

			{!!accountMintPassBalance && accountMintPassBalance > 0 && (
				<ElementWrapper>
					<TokensWrapper>{tokenElements}</TokensWrapper>
				</ElementWrapper>
			)}
		</DashboardWrapper>
	)
}

export default MintPassDashboard
